import React, { useId, useState } from "react";

/** Keep header tooltips anchored in CSS so body zoom cannot shift their arrows. */
export function HeaderTooltip({
  title,
  children,
  align = "center",
}: {
  title: string;
  children: React.ReactElement<React.HTMLAttributes<HTMLElement>>;
  align?: "center" | "end";
}) {
  const id = useId();
  const [open, setOpen] = useState(false);
  return (
    <span
      style={{ position: "relative", display: "inline-flex", flexShrink: 0 }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      onKeyDown={(event) => {
        if (event.key === "Escape") setOpen(false);
      }}
    >
      {React.cloneElement(children, {
        "aria-describedby": open ? id : children.props["aria-describedby"],
      })}
      {open && (
        <span
          id={id}
          role="tooltip"
          style={{
            position: "absolute",
            top: "calc(100% + 10px)",
            ...(align === "end"
              ? { right: 0 }
              : { left: "50%", transform: "translateX(-50%)" }),
            zIndex: 1500,
            padding: "6px 10px",
            borderRadius: 6,
            background: "#616161",
            color: "#fff",
            font: "500 11px/1.4 system-ui",
            whiteSpace: "nowrap",
            pointerEvents: "none",
          }}
        >
          <span
            aria-hidden="true"
            style={{
              position: "absolute",
              top: -4,
              ...(align === "end"
                ? { right: 10.5 }
                : { left: "calc(50% - 4px)" }),
              width: 8,
              height: 8,
              transform: "rotate(45deg)",
              background: "inherit",
            }}
          />
          {title}
        </span>
      )}
    </span>
  );
}
